import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { CakeToOrderPageState } from './state';
import { CakeToOrderPageActions } from './actions';
import { createCakeToOrderFromGetCakeToOrderApiResponse } from '../utils';

const initialState: CakeToOrderPageState = {
    loaded: false,
    errors: [],
};

export const cakeToOrderPageSlice = createSlice({
    name: 'cakeToOrderPageSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        /**
         * Получение записи по uid
         */
        builder.addCase(
            CakeToOrderPageActions.getCakeToOrderByUid.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const result = createCakeToOrderFromGetCakeToOrderApiResponse(
                            response.data,
                        );
                        state.cakeToOrder = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                        // return new BaseError(400, String(e));
                        // TODO
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
